import miniTableCheckedMixin from "@/mixin/em/common/stuffs/table/miniTableCheckedMixin";

export default {
    mixins: [miniTableCheckedMixin],
    props: {
        enableEdit: {
            type: Boolean,
            default: false
        },
        editFormName: {
            type: String,
            default: 'default'
        },
        newRowSaveHolder: Object,
        disableEditBtn: {
            type: Number,
            default: 1//质数取模：2(new)，3(edit)，5(delete); if val % 2 === 0 then disable new btn else if ...
        },
    },
    data() {
        return {
            editFormMap: {},

            editNew: false,
            currentEditRow: {},
            saveLoading: false,
            deleteLoading: false,
        }
    },
    computed: {
        editFormConfig() {
            if (this.editFormName) {
                let tempList = [];
                let fields = this.editFormMap[this.editFormName];
                if (fields) {
                    for (let item of this.fields) {
                        if (fields.includes(item.key)) {
                            tempList.push(item);
                        }
                    }
                }
                return tempList;
            }
            return [];
        },
    },
    methods: {
        openEditForm(newRow = false) {
            this.editNew = false;
            if (newRow) {
                let temp = {};
                if (this.newRowSaveHolder) {
                    for (let key of Object.keys(this.newRowSaveHolder)) {
                        temp[key] = this.newRowSaveHolder[key];
                    }
                }
                this.currentEditRow = temp;
                this.editNew = true;
            } else if (this.$_checkedOne) {
                this.currentEditRow = this.checkedRow;
            } else {
                return;
            }
            this.$refs.editForm.showModal();
        },
        deleteRows() {
            if (this.service && this.$_checked) {
                this.deleteLoading = true;
                this.$store.dispatch('api/post', {
                    url: `${process.env.VUE_APP_EM_GATEWAY_URL}/${this.service}/common/edit?id=${this.configId}`,
                    data: {
                        deleteIds: this.checkedIdList
                    }
                }).then(() => {
                    this.$message.success("Delete success");
                    this.queryRows();
                }).finally(() => this.deleteLoading = false);
            }
        },
        saveEdit() {
            if (this.service) {
                let obj = this.$refs._miniTable.collectInlineEditData();
                if (obj.deleteIds && obj.deleteIds.length > 0 || obj.editRows && obj.editRows.length > 0) {
                    this.saveLoading = true;
                    this.$store.dispatch('api/post', {
                        url: `${process.env.VUE_APP_EM_GATEWAY_URL}/${this.service}/common/edit?id=${this.configId}`,
                        data: obj
                    }).then(() => {
                        this.$message.success("Save success");
                        this.queryRows();
                    }).finally(() => this.saveLoading = false);
                }
            }
        },
        saveRow(row, continuous = false) {
            if (this.service) {
                this.saveLoading = true;
                this.$store.dispatch('api/post', {
                    url: `${process.env.VUE_APP_EM_GATEWAY_URL}/${this.service}/common/edit?id=${this.configId}`,
                    data: {
                        formName: this.editFormName,
                        editRows: [row]
                    }
                }).then(() => {
                    this.$message.success("Save success");
                    if (!continuous) {
                        this.queryRows();
                        this.$refs.editForm.hide();
                    }
                }).finally(() => this.saveLoading = false);
            }
        },
    }
}
